import React, { useState } from 'react'
import { TextInput } from '@siftscience/focus-components/input'
import { Button } from '@siftscience/focus-components/button'
import { makeStyles } from '@material-ui/core/styles'
import capitalize from '../../../../utils/capitalize'
import { snake } from '../../../../utils/snake'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  }
}))

export const AddColumnInline = ({
  onAdd,
  existingKeys
}: {
  onAdd: (title: string, key?: string) => void
  existingKeys: string[]
}) => {
  const classes = useStyles()
  const [title, setTitle] = useState('')
  const [keyInput, setKeyInput] = useState('')

  const handle = () => {
    const trimmed = title.trim()
    const keyTrim = keyInput.trim()
    if (!trimmed && !keyTrim) return

    const generated = snake(keyTrim || trimmed)
    if (existingKeys.includes(generated)) {
      return
    }

    onAdd(trimmed || capitalize(generated), keyTrim)
    setTitle('')
    setKeyInput('')
  }

  return (
    <div className={classes.container}>
      <TextInput
        id={'title'}
        value={title}
        onChange={e => setTitle(e.target.value)}
        placeholder="Title"
      />
      <TextInput
        id={'key'}
        value={keyInput}
        onChange={e => setKeyInput(e.target.value)}
        placeholder="Key"
      />
      <Button variant="secondary" lined onClick={handle}>
        + Add column
      </Button>
    </div>
  )
}
